<template>
  <section class="container">
    <ul
      class="flex flex-wrap justify-center gap-4"
      :class="{
        'sm:justify-center': items.length <= 2,
        'sm:justify-start': items.length >= 3,
      }"
    >
      <li
        v-for="(item, index) in items"
        :key="keyExtractor ? keyExtractor(item, index) : index"
        :class="{
          'w-full max-w-[468px]': items.length === 1,
          'w-full max-w-[468px] sm:w-[calc(50%-0.5rem)]': items.length === 2,
          'w-full sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)]': items.length >= 3,
        }"
      >
        <slot :item="item" :index="index"></slot>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts" generic="T">
defineProps<{
  items: T[]
  keyExtractor?: (item: T, index: number) => string | number
}>()
</script>
